import { useEffect, useRef,useState} from "react";
import { getToken, getUserId,setInizio,setFine,getInizio,getFine,getLingua } from "../auth";
import funzione_collegamento from "../funzioni_server/pacchetti_lez_function.js";
import  differenzaOrario  from "../funzioni/differenza_ore";
import "../stili/tabelle.css";
import "../stili/popup.css";
import "../stili/tabs.css"
import "../stili/analisi.css"
import "../stili/agenda.css"
import convertDate from "../funzioni/converti_data";
import { DateTime } from 'luxon';
import nome_id from "../funzioni/nome_id.js"
import {convertiIdInventario,convertiValuta,convertiColore,convertiTaglia,convertiTipoAccessori,convertiIdEscursione,convertiTipoStorage,convertiIdNoleggio,ordinaPerData,prendiNomePacchetto,coloreDaId,guadagnoEscursione,pacchettiAperti,materialeDisponibile,istruttori_disponibili,isoToString,calcolaStipendioFisso,convertiCambi} from "../funzioni/funzioni_utili"
import ReactDOM from "react-dom/client";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck,faDollarSign,faX,faStore, faPencil, faTrashCan,faCircleInfo,faSpinner,faChartSimple } from "@fortawesome/free-solid-svg-icons";
import Lottie from "lottie-react";
import animLoading from "../assets/loading.json";
import status_lezione from "../funzioni/status_lezione"
/* global $ */
function IstruttoreLezioni(){
const traduzioni = {
pagato: {
    1: "Pagato",
    2: "Paid",
    3: "Bezahlt",
    4: "Pagado"
  },
inizioLezione: {
    1: "Inizio Lezione",
    2: "Lesson Start",
    3: "Unterrichtsbeginn",
    4: "Inicio de clase"
  },
  fineLezione: {
    1: "Fine Lezione",
    2: "Lesson End",
    3: "Unterrichtsende",
    4: "Fin de clase"
  },
  nomeStudente: {
    1: "Nome Studente",
    2: "Student Name",
    3: "Name des Schülers",
    4: "Nombre del estudiante"
  },
  durataLezione: {
    1: "Durata Lezione",
    2: "Lesson Duration",
    3: "Unterrichtsdauer",
    4: "Duración de la clase"
  },
  stipendioLezione: {
    1: "Stipendio Lezione",
    2: "Lesson Salary",
    3: "Unterrichtsvergütung",
    4: "Salario de la clase"
  },
  pagamentoRimanente: {
    1: "Da pagare ancora a",
    2: "Still to pay to",
    3: "Noch zu zahlen an",
    4: "Aún por pagar a"
  },
  dettagliLezioni: {
    1: "Dettagli lezioni",
    2: "Lesson details",
    3: "Unterrichtsdetails",
    4: "Detalles de clases"
  },
    dettagliPagamenti: {
  1: "Dettagli pagamenti",
  2: "Payment details",
  3: "Zahlungsdetails",
  4: "Detalles de pagos"
},
  dettagliStipendiFissi: {
    1: "Dettagli stipendi fissi",
    2: "Fixed salary details",
    3: "Details Festgehälter",
    4: "Detalles de salarios fijos"

},
  periodoCompleto: {
    1: "Periodo che va dal {from} al {to}",
    2: "Period from {from} to {to}",
    3: "Zeitraum vom {from} bis {to}",
    4: "Período del {from} al {to}"
  },
  diLezioni: {
    1: "di lezioni",
    2: "from lessons",
    3: "aus Unterricht",
    4: "de lecciones"
  },
  diFisso: {
    1: "di fisso",
    2: "fixed salary",
    3: "Fixgehalt",
    4: "fijo"
  },
  totaleOre: {
    1: "Totale ore",
    2: "Total hours",
    3: "Gesamtstunden",
    4: "Horas totales"
  }
}

function generaStipendi(userid, salary, salarytype, startdate, enddate, stipendiPagati) {
  const oggi = DateTime.now().startOf('day');
  const inizio = DateTime.fromFormat(startdate, "yyyyMMdd", { zone: "utc" }).startOf('day');
  const fineLavoro = enddate
    ? DateTime.fromFormat(enddate, "yyyyMMdd", { zone: "utc" }).startOf('day')
    : oggi;

  let stipendi = [];

  const pagatiMap = new Map();
  for (let s of stipendiPagati) {
    const key = s.salarydateto;
    if (!pagatiMap.has(key)) {
      pagatiMap.set(key, { totale: 0, dati: [] });
    }
    pagatiMap.get(key).totale += s.importo;
    pagatiMap.get(key).dati.push({ ...s, pagato: true });
  }

  // Aggiungiamo direttamente gli stipendi già pagati
  for (let group of pagatiMap.values()) {
    for (let s of group.dati) {
      stipendi.push(s);
    }
  }
  if (salarytype === 1) {
    let data = inizio;

    while (data.weekday !== 4 && data.toMillis()!==fineLavoro.toMillis()) {
      data = data.plus({ days: 1 });
    }

    // Primo stipendio parziale se necessario
    if (inizio < data) {
      const giorni = data.diff(inizio, 'days').days;
      const importoParziale = Math.round((salary / 7) * giorni);
      const keyStart = inizio.toFormat("yyyyMMdd");
      const keyEnd = data.toFormat("yyyyMMdd");

      if (data <= oggi ) {
        const pagato = pagatiMap.get(keyEnd)?.totale || 0;
        const residuo = importoParziale - pagato;
        if (residuo > 0 && !pagatiMap.has(keyEnd)) {
          stipendi.push({
            userid,
            salarydatefrom: keyStart,
            salarydateto: keyEnd,
            importo: residuo,
            pagato: false
          });
        }
      }
    }

    // Salari settimanali
    while (data <= oggi && data <= fineLavoro) {
      const keyStart = data.toFormat("yyyyMMdd");
      const dataFine = data.plus({ days: 7 });
      const keyEnd = dataFine.toFormat("yyyyMMdd");

      if (dataFine <= oggi && dataFine <= fineLavoro) {
        const pagato = pagatiMap.get(keyEnd)?.totale || 0;
        const residuo = salary - pagato;

        if (residuo > 0 && !pagatiMap.has(keyEnd)) {
          stipendi.push({
            userid,
            salarydatefrom: keyStart,
            salarydateto: keyEnd,
            importo: residuo,
            pagato: false
          });
        }
      }

      data = data.plus({ days: 7 });
    }

  } else if (salarytype === 0) {
    // Mensile (1° del mese)
    let data = inizio;
    if (data.day !== 1) {
      const fineMese = data.endOf('month');
      const giorniLavorati = fineMese.diff(data, 'days').days + 1;
      const giorniTotali = fineMese.daysInMonth;
      const importoParziale = Math.round((salary / giorniTotali) * giorniLavorati);
      const keyStart = data.toFormat("yyyyMMdd");
      const keyEnd = fineMese.plus({ days: 1 }).startOf('day').toFormat("yyyyMMdd");

      if (fineMese <= oggi && fineMese <= fineLavoro) {
        const pagato = pagatiMap.get(keyEnd)?.totale || 0;
        const residuo = importoParziale - pagato;

        if (residuo > 0 && !pagatiMap.has(keyEnd)) {
          stipendi.push({
            userid,
            salarydatefrom: keyStart,
            salarydateto: keyEnd,
            importo: residuo,
            pagato: false
          });
        }
      }

      data = fineMese.plus({ days: 1 }).startOf('month');
    }

    // Stipendi mensili regolari
    while (data <= oggi && data <= fineLavoro) {
      const keyStart = data.toFormat("yyyyMMdd");
      const dataFine = data.plus({ months: 1 });
      const keyEnd = dataFine.toFormat("yyyyMMdd");

      if (dataFine <= oggi && dataFine <= fineLavoro) {
        const pagato = pagatiMap.get(keyEnd)?.totale || 0;
        const residuo = salary - pagato;

        if (residuo > 0 && !pagatiMap.has(keyEnd)) {
            stipendi.push({
            userid,
            salarydatefrom: keyStart,
            salarydateto: keyEnd,
            importo: residuo,
            pagato: false
          });
        }
      }

      data = data.plus({ months: 1 });
    }
  }

  // Ordinamento cronologico
  stipendi.sort((a, b) => a.salarydatefrom.localeCompare(b.salarydatefrom));

  return stipendi;
}


function mostraDettagliPagamenti(cellInfoUtente,periodi,stipendiUtente,lezioniUtente,pacchetti){
    let periodiInteressati=[]
    let elementi=[]
    for (let periodo of periodi){
        if (periodo.userid===cellInfoUtente.data.userid){
            periodiInteressati=[...periodiInteressati,periodo]
        }
    }
    periodiInteressati=ordinaPerData(periodiInteressati,"workperioddatefrom",true)
    const divGen=document.createElement("div")
    divGen.id="divGen"
    let rimanenzaTotale=0
    let rimanenzaLezioni=0
    let totaleOre=0
    for (let periodo of periodiInteressati){
        let stipendiPeriodo=[]
        let stipendiPeriodoOre=[]
        for (let stipendio of stipendiUtente){
            if(  stipendio.salaryfixed===0 && (DateTime.fromFormat(stipendio["salarydateto"],"yyyyMMdd",{zone:"utc"})<=DateTime.fromFormat(periodo["workperioddateto"],"yyyyMMdd",{zone:"utc"})&&DateTime.fromFormat(stipendio["salarydateto"],"yyyyMMdd",{zone:"utc"})>=DateTime.fromFormat(periodo["workperioddatefrom"],"yyyyMMdd",{zone:"utc"}))  ){
                stipendiPeriodo=[...stipendiPeriodo,stipendio]
            }
            else if (  stipendio.salaryfixed===1 && (DateTime.fromFormat(stipendio["salarydateto"],"yyyyMMdd",{zone:"utc"})<=DateTime.fromFormat(periodo["workperioddateto"],"yyyyMMdd",{zone:"utc"})&&DateTime.fromFormat(stipendio["salarydateto"],"yyyyMMdd",{zone:"utc"})>=DateTime.fromFormat(periodo["workperioddatefrom"],"yyyyMMdd",{zone:"utc"}))  ) {
                stipendiPeriodoOre=[...stipendiPeriodoOre,stipendio]
            }
        }
        let lezioniPeriodo=[]
        for (let lezione of lezioniUtente){
            if( DateTime.fromFormat(lezione["lessondatestart"],"yyyyMMddHHmm",{zone:"utc"})<=DateTime.fromFormat(periodo["workperioddateto"],"yyyyMMdd",{zone:"utc"})&&DateTime.fromFormat(lezione["lessondatestart"],"yyyyMMddHHmm",{zone:"utc"})>=DateTime.fromFormat(periodo["workperioddatefrom"],"yyyyMMdd",{zone:"utc"})){
                lezioniPeriodo=[...lezioniPeriodo,lezione]
            }
        }
        const stipendi = generaStipendi(
          cellInfoUtente.data.userid,
          periodo.workperiodfixedsalary,
          periodo.workperiodfixedsalaryfreq,
          periodo.workperioddatefrom,
          periodo.workperioddateto,
          stipendiPeriodo
        );
        for (let stipendio of stipendi){
            if (!stipendio.pagato){
                rimanenzaTotale+=stipendio.importo
            }
        }
        let totalePagatoV=0
        for (let stipendio of stipendiPeriodoOre){
            if (stipendio.salaryfixed!==0){
                totalePagatoV+=stipendio.salaryvalue
            }
        }
        let totaleGuadagnato=0
        for (let lezione of lezioniPeriodo ){
            for (let pacchetto of pacchetti){
                if (pacchetto.lessonid===lezione.lessonid){
                    const nome = pacchetto.lessonstudentname
                    const numero = pacchetto.lessonnumstudents
                    const durata=(convertDate(lezione.lessondateend)-convertDate(lezione.lessondatestart))/(3600*1000)
                    let paga= numero===1?durata*(periodo.workperiodhourlypayment):durata*(periodo.workperiodhourlypaymentgroups)
                    if (cellInfoUtente.data.ruolo===5 && pacchetto.lessontype==="Avanzata"){
                        let commissionLez=0
                        if (lezione.inventories.length>0)
                            commissionLez=periodo.workperiodcommissionratelessonmaterial/100
                        else
                            commissionLez=periodo.workperiodcommissionratelesson/100
                        paga=((pacchetto.lessoncost * (1 - (pacchetto.lessondiscount || 0) / 100))*commissionLez*durata)/pacchetto.lessonpacket
                    }
                    rimanenzaTotale+=paga
                    rimanenzaLezioni+=paga
                    totaleOre+=durata
                    totaleGuadagnato+=paga
                }
            }
        }
        let daPagarCom=0
        let contatoreLezioniCom=0
        let esci=false
        while ( daPagarCom<totalePagatoV && !(esci) && contatoreLezioniCom<=Object.keys(lezioniPeriodo).length ){
            const lezione=lezioniPeriodo[contatoreLezioniCom]
            for (let pacchetto of pacchetti){
                if ( lezione && pacchetto.lessonid===lezione.lessonid){
                    const nome = pacchetto.lessonstudentname
                    const numero = pacchetto.lessonnumstudents
                    const durata=(convertDate(lezione.lessondateend)-convertDate(lezione.lessondatestart))/(3600*1000)
                    let paga= numero===1?durata*(periodo.workperiodhourlypayment):durata*(periodo.workperiodhourlypaymentgroups)
                    if (cellInfoUtente.data.ruolo===5 && pacchetto.lessontype==="Avanzata"){
                        let commissionLez=0
                        if (lezione.inventories.length>0)
                            commissionLez=periodo.workperiodcommissionratelessonmaterial/100
                        else
                            commissionLez=periodo.workperiodcommissionratelesson/100
                        paga=((pacchetto.lessoncost * (1 - (pacchetto.lessondiscount || 0) / 100))*commissionLez*durata)/pacchetto.lessonpacket
                    }
                    totaleOre-=durata
                    daPagarCom+=paga
                }
                if (!lezione) esci=true
            }
            contatoreLezioniCom+=1

        }
        daPagarCom=totalePagatoV
        rimanenzaTotale-=totalePagatoV
        rimanenzaLezioni-=totalePagatoV
    }

    elementi.push(<h2 style={{ fontFamily: "Poppins", color: "red", fontWeight: "bold", fontSize: "22px" }}>
  {(cellInfoUtente.data.ruolo === 2 || cellInfoUtente.data.ruolo === 5) ? (
    periodiInteressati[0]["workperiodfixedsalary"] !== 0 ? (
      `${traduzioni.pagamentoRimanente[parseInt(getLingua())]} ${cellInfoUtente.data.nome} ${rimanenzaTotale}${convertiValuta(periodiInteressati[0]["workperiodfixedsalarycurrency"])}, ` +
      `${traduzioni.diLezioni[parseInt(getLingua())]}: ${rimanenzaLezioni}${convertiValuta(periodiInteressati[0]["workperiodfixedsalarycurrency"])}, ` +
      `${traduzioni.diFisso[parseInt(getLingua())]}: ${rimanenzaTotale - rimanenzaLezioni}${convertiValuta(periodiInteressati[0]["workperiodfixedsalarycurrency"])}. ` +
      `${traduzioni.totaleOre[parseInt(getLingua())]}: ${differenzaOrario({ dataInizio: totaleOre * 3600 * 1000 })}`
    ) : (
      `${traduzioni.pagamentoRimanente[parseInt(getLingua())]} ${cellInfoUtente.data.nome} ${rimanenzaTotale}${convertiValuta(periodiInteressati[0]["workperiodfixedsalarycurrency"])}. ` +
      `${traduzioni.totaleOre[parseInt(getLingua())]}: ${differenzaOrario({ dataInizio: totaleOre * 3600 * 1000 })}`
    )
  ) : (
    `${traduzioni.pagamentoRimanente[parseInt(getLingua())]} ${cellInfoUtente.data.nome} ${rimanenzaTotale}${convertiValuta(periodiInteressati[0]["workperiodfixedsalarycurrency"])} ` +
    `${traduzioni.diFisso[parseInt(getLingua())]}.`
  )}
</h2>

)
    for (let periodo of periodiInteressati){

         let stipendiPeriodo=[]
        let stipendiPeriodoOre=[]
        for (let stipendio of stipendiUtente){
            if(  stipendio.salaryfixed===0 && (DateTime.fromFormat(stipendio["salarydateto"],"yyyyMMdd",{zone:"utc"})<=DateTime.fromFormat(periodo["workperioddateto"],"yyyyMMdd",{zone:"utc"})&&DateTime.fromFormat(stipendio["salarydateto"],"yyyyMMdd",{zone:"utc"})>=DateTime.fromFormat(periodo["workperioddatefrom"],"yyyyMMdd",{zone:"utc"}))  ){
                stipendiPeriodo=[...stipendiPeriodo,stipendio]
            }
            else if (  stipendio.salaryfixed===1 && (DateTime.fromFormat(stipendio["salarydateto"],"yyyyMMdd",{zone:"utc"})<=DateTime.fromFormat(periodo["workperioddateto"],"yyyyMMdd",{zone:"utc"})&&DateTime.fromFormat(stipendio["salarydateto"],"yyyyMMdd",{zone:"utc"})>=DateTime.fromFormat(periodo["workperioddatefrom"],"yyyyMMdd",{zone:"utc"}))  ) {
                stipendiPeriodoOre=[...stipendiPeriodoOre,stipendio]
            }
        }
        let lezioniPeriodo=[]
        for (let lezione of lezioniUtente){
            if( DateTime.fromFormat(lezione["lessondatestart"],"yyyyMMddHHmm",{zone:"utc"})<=DateTime.fromFormat(periodo["workperioddateto"],"yyyyMMdd",{zone:"utc"})&&DateTime.fromFormat(lezione["lessondatestart"],"yyyyMMddHHmm",{zone:"utc"})>=DateTime.fromFormat(periodo["workperioddatefrom"],"yyyyMMdd",{zone:"utc"})){
                lezioniPeriodo=[...lezioniPeriodo,lezione]
            }
        }
        const commento=document.createElement("h1")
        if (periodo.workperiodfixedsalary!==0)
            elementi.push(<div>
           <h1 style={{ fontWeight: "bold", fontFamily: "Poppins", fontSize: "25px" }}>
  {traduzioni.periodoCompleto[parseInt(getLingua())]
    .replace("{from}", DateTime.fromFormat(periodo.workperioddatefrom, "yyyyMMdd", { zone: 'utc' }).toFormat("dd/MM/yyyy"))
    .replace("{to}", DateTime.fromFormat(periodo.workperioddateto, "yyyyMMdd", { zone: 'utc' }).toFormat("dd/MM/yyyy"))}
</h1>

            <h2>{traduzioni.dettagliStipendiFissi[parseInt(getLingua())]}</h2>
            <div id={"gridContainerStipendi"+periodo.workperioddatefrom}></div>
            <h2>{traduzioni.dettagliLezioni[parseInt(getLingua())]}</h2>
            <div id={"gridContainerOre"+periodo.workperioddatefrom}></div>
                <h2>{traduzioni.dettagliPagamenti[parseInt(getLingua())]}</h2>
            <div id={"gridContainerPagOre"+periodo.workperioddatefrom}></div>
            </div>)
        else
        elementi.push(<div>
            <h1 style={{ fontWeight: "bold", fontFamily: "Poppins", fontSize: "25px" }}>
  {traduzioni.periodoCompleto[parseInt(getLingua())]
    .replace("{from}", DateTime.fromFormat(periodo.workperioddatefrom, "yyyyMMdd", { zone: 'utc' }).toFormat("dd/MM/yyyy"))
    .replace("{to}", DateTime.fromFormat(periodo.workperioddateto, "yyyyMMdd", { zone: 'utc' }).toFormat("dd/MM/yyyy"))}
</h1>
            <h2>{traduzioni.dettagliLezioni[parseInt(getLingua())]}</h2>
            <div id={"gridContainerOre"+periodo.workperioddatefrom}></div>
            <h2>{traduzioni.dettagliPagamenti[parseInt(getLingua())]}</h2>
            <div id={"gridContainerPagOre"+periodo.workperioddatefrom}></div>
            </div>)
        let formattedRowsOre=[]
        let formattedRowsStipendi=[]
        let formattedRowsStipendiOre=[]
        const allineamento="center"
        const stipendi = generaStipendi(
          cellInfoUtente.data.userid,
          periodo.workperiodfixedsalary,
          periodo.workperiodfixedsalaryfreq,
          periodo.workperioddatefrom,
          periodo.workperioddateto,
          stipendiPeriodo
        );
        let contatore=0
        for (let stipendio of stipendi){
            contatore-=1
            formattedRowsStipendi=[...formattedRowsStipendi,{"id":stipendio.salaryid?stipendio.salaryid:contatore,"inizio":convertDate(stipendio.salarydatefrom).toISO({ includeOffset: false }),"fine":convertDate(stipendio.salarydateto).toISO({ includeOffset: false }),"importo":stipendio.importo?stipendio.importo:stipendio.salaryvalue,"pagato":stipendio.pagato}]
        }
        for (let stipendio of stipendiPeriodoOre){
            if (stipendio.salaryfixed!==0)
            formattedRowsStipendiOre=[...formattedRowsStipendiOre,{"salaryid":stipendio.salaryid,"data":convertDate(stipendio.salarydateto).toISO({ includeOffset: false }),"importo":stipendio.salaryvalue,"valuta":stipendio.salarycurrency,note:stipendio.salarynotes}]
        }
        let formattedRowsLezioni=[]
        let totaleIncome=0
        for (let lezione of lezioniPeriodo){
            for (let pacchetto of pacchetti){
                if (pacchetto.lessonid===lezione.lessonid){
                    const nome = pacchetto.lessonstudentname
                    const numero = pacchetto.lessonnumstudents
                    const durata=((convertDate(lezione.lessondateend)-convertDate(lezione.lessondatestart))/(3600*1000))
                    let paga= numero===1?((convertDate(lezione.lessondateend)-convertDate(lezione.lessondatestart))/(3600*1000))*(periodo.workperiodhourlypayment):((convertDate(lezione.lessondateend)-convertDate(lezione.lessondatestart))/(3600*1000))*(periodo.workperiodhourlypaymentgroups)
                    if (cellInfoUtente.data.ruolo===5 && pacchetto.lessontype==="Avanzata"){
                        let commissionLez=0
                        if (lezione.inventories.length>0)
                            commissionLez=periodo.workperiodcommissionratelessonmaterial/100
                        else
                            commissionLez=periodo.workperiodcommissionratelesson/100
                        paga=((pacchetto.lessoncost * (1 - (pacchetto.lessondiscount || 0) / 100))*commissionLez*durata)/pacchetto.lessonpacket
                    }
                    totaleIncome+=paga
                    formattedRowsLezioni=[...formattedRowsLezioni,{"lessondateid":lezione.lessondateid,"inizio":convertDate(lezione.lessondatestart).toISO({ includeOffset: false }),"fine":convertDate(lezione.lessondateend).toISO({ includeOffset: false }),"studente":nome,"duratams":convertDate(lezione.lessondateend)-convertDate(lezione.lessondatestart),"durata":differenzaOrario({dataInizio:convertDate(lezione.lessondateend)-convertDate(lezione.lessondatestart)}),"stipendiolez":paga,"pagato":0}]
                }
            }
        }
        let daPagar=0
        let contatoreLezioni=0
        let totalePagatoV=0
        for (let stipendio of stipendiPeriodoOre){
            if (stipendio.salaryfixed!==0){
                totalePagatoV+=stipendio.salaryvalue
            }
        }
        let esciWhile=false
        while (daPagar<totalePagatoV){
            const lezione=lezioniPeriodo[contatoreLezioni]
            for (let pacchetto of pacchetti){
                if ( lezione && pacchetto.lessonid===lezione.lessonid){
                    const nome = pacchetto.lessonstudentname
                    const numero = pacchetto.lessonnumstudents
                    const durata=(convertDate(lezione.lessondateend)-convertDate(lezione.lessondatestart))/(3600*1000)
                    let paga= numero===1?durata*(periodo.workperiodhourlypayment):durata*(periodo.workperiodhourlypaymentgroups)
                    if (cellInfoUtente.data.ruolo===5 && pacchetto.lessontype==="Avanzata"){
                        let commissionLez=0
                        if (lezione.inventories.length>0)
                            commissionLez=periodo.workperiodcommissionratelessonmaterial/100
                        else
                            commissionLez=periodo.workperiodcommissionratelesson/100
                        paga=((pacchetto.lessoncost * (1 - (pacchetto.lessondiscount || 0) / 100))*commissionLez*durata)/pacchetto.lessonpacket
                    }
                    daPagar+=paga
                    formattedRowsLezioni[contatoreLezioni].pagato=1

                }
                else if (!lezione){
                    esciWhile=true
                }
            }
            contatoreLezioni+=1
            if (esciWhile)break

        }
        const ultimeLezioni = {};
formattedRowsLezioni.forEach(lezione => {
    const dt = DateTime.fromISO(lezione.inizio);
    if (!ultimeLezioni[lezione.studente] || dt > DateTime.fromISO(ultimeLezioni[lezione.studente])) {
        ultimeLezioni[lezione.studente] = lezione.inizio; // salvo come stringa ISO
    }
});
    setTimeout(()=>{
       $("#gridContainerOre"+periodo.workperioddatefrom).dxDataGrid({
    dataSource: formattedRowsLezioni,
    keyExpr: "lessondateid",
    showBorders: true,
    grouping: { autoExpandAll: true },
    columnsAutoWidth: true,
    columnHidingEnabled: true,
    rowAlternationEnabled: true,
    columns: [
        {
            dataField: "inizio",hidingPriority:3,
            caption: traduzioni.inizioLezione[parseInt(getLingua())],
            sortOrder: "desc", // lezioni decrescenti nel gruppo
            customizeText: e => DateTime.fromISO(e.value).toFormat("dd/MM/yyyy, HH:mm")
        },
        {
            dataField: "fine",hidingPriority:2,
            caption: traduzioni.fineLezione[parseInt(getLingua())],
            customizeText: e => DateTime.fromISO(e.value).toFormat("dd/MM/yyyy, HH:mm")
        },
        {
            dataField: "studente",
            caption: traduzioni.nomeStudente[parseInt(getLingua())],
            groupIndex: 0,
             groupCellTemplate: function (cellElement, cellInfo) {
    const nome = cellInfo.value;
    const count = cellInfo.data.items?cellInfo.data.items:cellInfo.data.collapsedItems?cellInfo.data.collapsedItems:[];
    let oreTot=0;
    for (let lezione of count){
        oreTot+=lezione.duratams
    }
    cellElement.text(`👨‍🏫 ${nome} — ${differenzaOrario({dataInizio:oreTot})}`);
  }
        },
        {
            name: "IndiceOrdine",
            calculateCellValue: rowData => {
                // colonna nascosta che decide l'ordine dei gruppi
                return ultimeLezioni[rowData.studente];
            },
            visible: false,
            showInColumnChooser: false
        },
        { dataField: "durata", caption: traduzioni.durataLezione[parseInt(getLingua())],hidingPriority:5 },
        { dataField: "stipendiolez", alignment:"center",hidingPriority:4,caption: traduzioni.stipendioLezione[parseInt(getLingua())], calculateDisplayValue:function(rowData){
            return   `${rowData.stipendiolez.toFixed(2)} €`
            } },
        { dataField: "pagato", caption: traduzioni.pagato[parseInt(getLingua())], dataType: "boolean",hidingPriority:1 }
    ],
    summary: {
        groupItems: [{
            column: "IndiceOrdine",
            summaryType: "min",
            alignByColumn: true,
            name: "minIndice"
        }]
    },
     grouping: {autoExpandAll: false},
    sortByGroupSummaryInfo: [{
        summaryItem: "minIndice",
        sortOrder: "desc" // ultima lezione più recente prima
    }],
    onRowPrepared: function (e) {
        if (e.rowType === "group"){
            for (let riga of e.data.items?e.data.items:e.data.collapsedItems?e.data.collapsedItems:[]){
                if (!riga.pagato){
                    e.rowElement.addClass("row-warning2");
                    e.rowElement[0].bgColor = "#ffe6e6";
                }
            }
        }
        if (e.rowType === "data" && !e.data.pagato) {
            e.rowElement.addClass("row-warning");
            e.rowElement[0].bgColor = "#ffe6e6";
        }
    }
})
        $("#gridContainerStipendi"+periodo.workperioddatefrom).dxDataGrid({
            dataSource: formattedRowsStipendi,
      rowAlternationEnabled: true,
        columnAutoWidth: true,
        columnHidingEnabled: true,

      onRowPrepared: function (e) {
          if (e.rowType === "data" && e.rowElement && e.data) {
            if (!e.data.pagato) {
              e.rowElement.addClass("row-warning");
              e.rowElement[0].bgColor = "#ffe6e6";
            }
          }
        },

      columns: [
        { dataField: "inizio", caption: "Inizio periodo",hidingPriority:1,
         alignment:allineamento,
          customizeText: function (e) {
            return DateTime.fromISO(e.value).toFormat("dd/MM/yyyy");
          },},
        { dataField: "fine", caption: "Fine periodo",hidingPriority:3,alignment:allineamento,
          customizeText: function (e) {
            return DateTime.fromISO(e.value).toFormat("dd/MM/yyyy");
          },
          },
        { dataField: "importo", caption: "Importo",alignment:allineamento,hidingPriority:4, cellTemplate: (cellElement, cellInfo) => {
            const root = ReactDOM.createRoot(cellElement.get(0));
            root.render(
        <div style={{ fontFamily: "Poppins, sans-serif" }}>
            {cellInfo.value}{convertiValuta(periodo.workperiodfixedsalarycurrency)}
        </div>)},

          },

        {
          dataField: "pagato",hidingPriority:2,alignment:allineamento,
          caption: "Pagato",
          dataType: "boolean",
          allowEditing: false
        }
      ]
    });
       $("#gridContainerPagOre"+periodo.workperioddatefrom).dxDataGrid({
        dataSource:formattedRowsStipendiOre,
        columns:[
         {dataField:"importo",caption: "Importo Stipendio",hidingPriority:5,
         alignment:allineamento,
             calculateDisplayValue:function(rowData){return `${rowData.importo?rowData.importo.toLocaleString("it-IT", { maximumFractionDigits: 2 }):0} ${convertiValuta(rowData.valuta)}`}
         },
             { dataField: "valuta",visible:false, alignment:allineamento,caption:"Valuta stipendio",hidingPriority:5,customizeText: function (e){
          return convertiValuta(e.value)},
        },

         {
          dataField: "note",
          caption: "Note Stipendio",
        },
            {
            dataField: "data",
            caption: "Data",
            sortOrder: "desc",
            alignment:allineamento,
               customizeText: function(cellInfo) {

    if (!cellInfo.value) return "";

    let dt;

    if (typeof cellInfo.value === "string") {
        dt = DateTime.fromISO(cellInfo.value);
    } else if (cellInfo.value instanceof Date) {
        dt = DateTime.fromJSDate(cellInfo.value);
    } else {
        return "";
    }

    if (!dt.isValid) return "";

    return dt.toFormat("dd/MM/yyyy");
}
          },


        ],
        rowAlternationEnabled: true,
        columnAutoWidth: true,
        columnHidingEnabled: true,

        })


      },0)
    }
    return elementi
}
const [caricato, setCaricato] = useState(false);
  const [cellInfo, setCellInfo] = useState(null);
  const [periodi, setPeriodi] = useState([]);
  const [stipendiUtente, setStipendiUtente] = useState([]);
  const [lezioniUtente, setLezioniUtente] = useState([]);
  const [pacchetti, setPacchetti] = useState([]);

  useEffect(() => {
    const fetchDati = async () => {
      const userid = parseInt(getUserId());
      $("#loadingOverlay").show()
      let [lezioni, utenti, stipendi, pacchetti, periodi] = await Promise.all([
        funzione_collegamento({ userid, token: getToken(), azione: "getLessonDates", filtri:{lessondatestatus:2},childs:["inventories"]}),
        funzione_collegamento({ userid, token: getToken(), azione: "getUsers" }),
        funzione_collegamento({ userid, token: getToken(), azione: "getSalaryItems" }),
        funzione_collegamento({ userid, token: getToken(), azione: "getLessons" }),
        funzione_collegamento({ userid, token: getToken(), azione: "getUserWorkPeriods" }),
      ]);
      const utente = utenti.find(u => u.userid === userid) || {};

      const lezioniUtente = lezioni.filter(
        lezione => lezione.userid === userid && lezione.lessondatestatus === 2
      );

      const stipendiUtente = stipendi.filter(s => s.userid === userid);

      setCellInfo({ data: { nome: utente.name, ruolo: utente.type, userid: utente.userid } });
      setLezioniUtente(lezioniUtente);
      setStipendiUtente(stipendiUtente);
      setPacchetti(pacchetti);
      setPeriodi(periodi);
      setCaricato(true);
    };

    fetchDati();
  }, []);

  if (!caricato) return <div id="loadingOverlay">
      <div className="spinner">
        <Lottie  style={{ width: "30%", height: "30%" }} animationData={animLoading} loop={true} />
      </div>
    </div>

  return <div>
    {mostraDettagliPagamenti(cellInfo, periodi, stipendiUtente, lezioniUtente, pacchetti)}
  </div>
}

export default IstruttoreLezioni